export default __webpack_public_path__ + "static/media/abshar3.2f1b8e15.jpg";